(function () {
  'use strict';
  const dock = document.querySelector('[data-care-dock]');
  if (!dock || dock.dataset.ready) return;
  dock.dataset.ready = 'true';
  const toggle = dock.querySelector('[data-care-toggle]');
  const panel = dock.querySelector('.ep-care-dock__panel');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let pinned = false;
  let leaveTimer;
  let suppressHover = false;

  function setOpen(open) {
    clearTimeout(leaveTimer);
    dock.dataset.open = String(open);
    toggle.setAttribute('aria-expanded', String(open));
    panel.setAttribute('aria-hidden', String(!open));
    panel.inert = !open;
  }
  function collapse(restoreFocus) {
    pinned = false;
    suppressHover = dock.matches(':hover');
    setOpen(false);
    if (restoreFocus) toggle.focus({preventScroll: true});
  }
  toggle.addEventListener('pointerenter', event => {
    if (event.pointerType === 'mouse' && finePointer.matches && !suppressHover && !document.querySelector('dialog[open]')) setOpen(true);
  });
  dock.addEventListener('pointerenter', () => clearTimeout(leaveTimer));
  dock.addEventListener('pointerleave', () => {
    suppressHover = false;
    if (!pinned && !dock.contains(document.activeElement)) leaveTimer = setTimeout(() => setOpen(false), 180);
  });
  toggle.addEventListener('click', () => {
    if (pinned) { collapse(false); return; }
    pinned = true;
    suppressHover = false;
    setOpen(true);
    panel.querySelector('a').focus({preventScroll: true});
  });
  dock.querySelector('[data-care-collapse]').addEventListener('click', () => collapse(true));
  dock.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); collapse(true); }
  });
  dock.addEventListener('focusout', event => {
    if (!dock.contains(event.relatedTarget) && !pinned) setOpen(false);
  });
  document.addEventListener('pointerdown', event => {
    if (dock.dataset.open === 'true' && !dock.contains(event.target) && !document.querySelector('dialog[open]')) collapse(false);
  });
})();
